import React from 'react';

const PreloaderSpin = () => {
  return (
    <div className="w-full h-full absolute top-0 left-0 bg-white opacity-75 flex justify-center items-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
    </div>
  );
};

export default PreloaderSpin;
